import {
    Stack,
    Text,
    Badge,
    Button,
    useMediaQuery,
    useColorModeValue
} from '@chakra-ui/react'

import moment from 'moment'
import currencyFormatter from 'currency-formatter'

import theme from '../../../../Config/theme'

import { MdAttachMoney, MdOutlineCalendarToday, MdOutlineMenuBook, MdLocationOn } from "react-icons/md";

const ScholarshipsItem = ({ data }) => {
    const isDesktop = useMediaQuery("(min-width: 768px)")
    const backgroundColor = useColorModeValue('gray.100', 'gray.800')
    const borderColor = useColorModeValue(theme.borderColor.borderColorLight, theme.borderColor.borderColorDark)

    return (
        <Stack direction={'column'} p={5} bgColor={backgroundColor} borderRadius={'md'} style={{ transition: 'transform .2s' }} _hover={{ transform: 'scale(1.03)', boxShadow: `5px 5px ${theme.default.defaultColor}` }} border={'1px'} borderColor={borderColor}>
            <Stack direction={{ base: 'column', md: 'row' }} justify={'space-between'} align={'center'}>
                <Stack direction={'column'} spacing={1}>
                    <Stack direction={{ base: 'column', md: 'row' }} align={'center'} fontWeight={'700'} pb={3}>
                        <Text fontSize={'lg'}>{data?.title}</Text>
                        {!data.essay_required && <Badge bgColor={theme.default.defaultColor} color={'black'} fontSize={'lg'} borderRadius={'full'} px={3}>No Essay</Badge>}
                    </Stack>
                    <Stack direction={'row'} align={'center'}>
                        <MdAttachMoney size={20} />
                        <Text>Est. Award Amount: {currencyFormatter.format(data.award_amount, { code: 'USD' })}</Text>
                    </Stack>
                    <Stack direction={'row'} align={'center'}>
                        <MdOutlineCalendarToday size={20} />
                        <Text>Deadline: {moment(data.deadline).format('MMMM Do YYYY')}</Text>
                    </Stack>
                    <Stack direction={'row'} align={'center'}>
                        <MdOutlineMenuBook size={20} />
                        <Text>Essay Required: {data.essay_required ? 'Yes' : 'No'}</Text>
                    </Stack>
                    <Stack direction={'row'} align={'center'}>
                        <MdLocationOn size={20} />
                        <Text>State: {data.state}</Text>
                    </Stack>
                </Stack>
                <a href={data.apply_url || 'https://daddysteach.com/'} target={'_blank'}>
                    <Button
                        bgColor={theme.default.defaultColor}
                        color={'black'}
                        size={'lg'}
                        borderRadius={'full'}
                        width={!isDesktop[0] && 'full'}
                        _hover={{}}
                        _active={{}}
                        _focis={{}}
                    >Apply</Button>
                </a>
            </Stack>
        </Stack>
    )
}

export default ScholarshipsItem